import React from 'react';
import { useAddSubscriptionPlanComponent } from './useAddSubscriptionPlanComponent';
import { Box, Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddSubscriptionPlan.styles';
import theme from '../../../../styles/theme';
import { ISubscriptionPlan } from '../../../../types/interfaces/subscription-plan';
import {
  SubscriptionPeriod,
  SubscriptionScope,
} from '../../../../shared/constants';
import AppFormTextField from '../../../../components/designe/app-form-text-field';

interface IAddSubscriptionPlanProps {
  subscriptionPlan: ISubscriptionPlan;
  onClose: () => void;
}

export default function AddSubscriptionPlan(props: IAddSubscriptionPlanProps) {
  const { subscriptionPlan, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddSubscriptionPlanComponent(
    onClose,
    subscriptionPlan,
  );
  const { classes } = useStyles(theme);
  const subscriptionScopeOptions = [
    {
      id: SubscriptionScope.starter,
      name: t(`superAdminDashboard.scope_${SubscriptionScope.starter}`),
    },
    {
      id: SubscriptionScope.pro,
      name: t(`superAdminDashboard.scope_${SubscriptionScope.pro}`),
    },
    {
      id: SubscriptionScope.trainer,
      name: t(`superAdminDashboard.scope_${SubscriptionScope.trainer}`),
    },
  ];

  const subscriptionPeriodOptions = [
    {
      id: SubscriptionPeriod.annual,
      name: t(`superAdminDashboard.period_${SubscriptionPeriod.annual}`),
    },
    {
      id: SubscriptionPeriod.monthly,
      name: t(`superAdminDashboard.period_${SubscriptionPeriod.monthly}`),
    },
  ];

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.scope')}
              name="scope"
              showSearch={false}
              disableClear
              options={subscriptionScopeOptions}
              defaultValue={subscriptionScopeOptions?.find(
                (r) => r.id === formik.values.scope,
              )}
              onChange={(e) => formik.setFieldValue('scope', e.target.value.id)}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.period')}
              name="period"
              showSearch={false}
              disableClear
              options={subscriptionPeriodOptions}
              defaultValue={subscriptionPeriodOptions?.find(
                (r) => r.id === formik.values.period,
              )}
              onChange={(e) =>
                formik.setFieldValue('period', e.target.value.id)
              }
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('superAdminDashboard.stripePlanId')}
              fullWidth
              name="stripePlanId"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.orderNumber')}
              fullWidth
              name="orderNumber"
              type="number"
              formik={formik}
            />
          </Grid>
        </Grid>
        <Box className={classes.addSubscriptionPlansButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {subscriptionPlan ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
